exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue2-dropzone/dist/vue2Dropzone.css"), "");

// module
exports.push([module.id, ".dropzone[data-v-fc643414]{text-align:center}.upload-area-enter-active[data-v-fc643414],.upload-area-leave-active[data-v-fc643414]{transition:all 1s}.upload-area-enter[data-v-fc643414],.upload-area-leave-to[data-v-fc643414]{opacity:0}.upload-area-enter[data-v-fc643414]{transform:translateY(300px)}.upload-area-leave-to[data-v-fc643414]{transform:translateY(-300px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fc643414","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/create/UploadSection.vue
// module id = 134
// module chunks = 6